import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PasswordInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const PasswordField = ({ field, onBlur, onChange, onFocus }) => {
  const {
    active,
    autocomplete,
    autofocus,
    disabled,
    errors,
    isTypeText,
    label,
    name,
    placeholder,
    touched,
    value,
    warnings,
  } = field;
  const inputValue = value === null ? '' : value;
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);
  const error = touched && errors[0];
  const warning = touched ? warnings?.[0]?.message : null;
  const success = touched && !error;

  return (
    <Field className="field-password" isSignupForm options={field}>
      <PasswordInput
        active={active}
        autoComplete={autocomplete}
        autoFocus={autofocus}
        disabled={disabled}
        error={error}
        isTypeText={isTypeText}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        success={success}
        touched={touched}
        value={inputValue}
        warning={warning}
      />
    </Field>
  );
};

PasswordField.propTypes = {
  field: PropTypes.shape({
    active: PropTypes.bool,
    autocomplete: PropTypes.string,
    autofocus: PropTypes.bool,
    disabled: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
    isTypeText: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    touched: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    warnings: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default PasswordField;
